import { createApp } from '@backstage/frontend-defaults';
import { appModuleNav } from './modules/appNavigationModules.tsx';
import { customHomePageModule } from './modules/homePageModules.tsx';
import { appModuleSignInPage } from './modules/azureIdentityProviderModules.tsx';
import { essityThemeModule } from '@internal/backstage-plugin-essity-theme';
import { pageLayoutModule } from './modules/pageLayoutModule.tsx';
import { scaffolderApiModule } from './modules/scaffolderApiModule.tsx';
import { pullRequestTaskBannerModule } from './modules/pullRequestTaskBanner.tsx';
import {
  azureEntraUserPickerFieldModule,
  entityDescriptionFieldModule,
  foundryModelPickerFieldModule,
  invoiceSectionPickerFieldModule,
  ipRangePickerFieldModule,
} from '@internal/backstage-plugin-essity-scaffolder-field-extensions';
import aiModelsPlugin from '@internal/backstage-plugin-ai-models';
import essityExploreMenuPlugin from '@internal/backstage-plugin-essity-explore-menu';
import rbacPlugin from '@backstage-community/plugin-rbac/alpha';

const features: any[] = [
  appModuleNav as any,
  appModuleSignInPage as any,
  customHomePageModule as any,
  essityThemeModule as any,
  pageLayoutModule as any,
  scaffolderApiModule as any,
  pullRequestTaskBannerModule as any,
  azureEntraUserPickerFieldModule as any,
  invoiceSectionPickerFieldModule as any,
  foundryModelPickerFieldModule as any,
  entityDescriptionFieldModule as any,
  ipRangePickerFieldModule as any,
  ...(aiModelsPlugin as any),
  essityExploreMenuPlugin as any,
  rbacPlugin as any,
];

const app = createApp({
  features,
});

const App = () => app.createRoot();

export default App;
